export default () => jQuery(($) => {
    $('#topics-menu > a').on('click', function(e){
        $('.news-site-subnav').toggleClass('topics-active');
        return false;
    })
    $('#subnav-menu-button').on('click', function(){
        $('.news-site-subnav').toggleClass('menu-active');
        return false;
    })
});
